import { render, staticRenderFns } from "./cancelCard.vue?vue&type=template&id=479753bc&scoped=true"
import script from "./cancelCard.vue?vue&type=script&lang=js"
export * from "./cancelCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479753bc",
  null
  
)

export default component.exports